/* eslint-disable */

import React, {useState, useEffect, useRef, useCallback, useMemo} from 'react'
import {Global, css} from '@emotion/react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {useLocation} from 'react-router-dom'

import {
  FileSpreadsheet,
  Loader2,
  Filter,
  ArrowUpDown,
  ArrowDown,
  ArrowUp,
  Download,
  Building2,
  HelpCircle,
} from 'lucide-react'
import {
  useReactTable,
  getCoreRowModel,
  getSortedRowModel,
  flexRender,
  createColumnHelper,
} from '@tanstack/react-table'
import Select from 'react-select'
import 'react-datepicker/dist/react-datepicker.css'
import {Modal} from 'react-bootstrap'
import FilterModal from './FilterModal'
import DownloadModal from './DownloadModal'
import {StatsCard} from './StatsCard'
import * as API from '../../../api'
import styled from '@emotion/styled'
import ReportsData from './ReportsData'
import {ReportTableBody} from './ReportTableBody'
import {formatCellValue} from './reportTableUtils'
import {HelpModal} from './HelpModal'
import { isSuperAdmin } from '../../../modules/auth/core/Auth';

interface ScreenProps {
  report: string
  title?: string
  reportMethod?: string
}

interface RowDetailField {
  key: string
  label: string
  value: string
}

interface SelectedRowDetails {
  rowNumber: number
  fields: RowDetailField[]
}

interface RowPointerInteraction {
  rowId: string
  startX: number
  startY: number
  moved: boolean
}

const MIN_COLUMN_WIDTH = 120
const MAX_COLUMN_WIDTH = 420
const DEFAULT_COLUMN_WIDTH = 200
const ROW_CLICK_DELAY_MS = 300
const ROW_DRAG_TOLERANCE_PX = 6

const StyledWrapper = styled.div`
  .filter-modal-dialog {
    width: 900px;
    max-width: 90vw;
  }
`

const REPLACE_COLUMNS_NAME = [
  ['IDPedido', 'Pedido'],
  ['DataAprovado', 'Data Aprovado'],
  ['DataFaturado', 'Data Faturado'],
  ['DataEntregue', 'Data Entregue'],
  ['DataCancelado', 'Data Cancelado'],
  ['DataApurado', 'Data Apurado'],
  ['CNPJLojista', 'CNPJ'],
  ['CNPJ', 'CNPJ'],
  ['CEP', 'CEP'],
  ['RazaoSocial', 'Razão Social'],
  ['Industria', 'Indústria'],
  ['Seller', 'Distribuidor'],
  ['UnidadeNegocio', 'Unidade de Negócio'],
  ['CepInicio', 'CEP Inicial'],
  ['CepFim', 'CEP Final'],
  ['StatusCadastro', 'Status do Cadastro'],
  ['IDZona', 'ID Zona'],
  ['PoliticaPrecoName', 'Política de Preço'],
  ['StatusAprovacaoERPSeller', 'Status de Aprovação no ERP do Distribuidor'],
  ['IDSku', 'SKU'],
  ['FamiliaProduto', 'Familia Produto'],
  ['GrupoProduto', 'Grupo Produto'],
  ['QuantidadeFaturada', 'Quantidade Faturada'],
  ['PrecoTotalSemDesconto', 'Preço Total Sem Desconto'],
  ['PrecoTotalComDesconto', 'Preço Total Com Desconto'],
  ['ValorFaturado', 'Valor Faturado'],
  ['ValorCorte', 'Valor Corte'],
  ['OrigemPedido', 'Origem Pedido'],
  ['TipoVenda', 'Tipo Venda'],
  ['MeioPagamento', 'Meio de Pagamento'],
  ['PrazoPagamento', 'Prazo de Pagamento'],
  ['NomeVendedor', 'Nome Vendedor'],
  ['IDDistribuidor', 'ID Distribuidor'],
  ['CNPJDistribuidor', 'CNPJ Distribuidor'],
  ['NomeCompletoDistribuidor', 'Nome Completo Distribuidor'],
  ['Status_Plataforma', 'Status Plataforma'],
  ['DataCadastro_magento', 'Data Cadastro Magento'],
  ['PrazosPagamento', 'Prazos de Pagamento'],
  ['Price_tp', 'Price TP'],
  ['Metodos_pagamento', 'Métodos de Pagamento'],
  ['ValorMinimoPedido', 'Valor Mínimo do Pedido'],
  ['Sellout_6m', 'Sellout 6m'],
  ['Ultimo_pedido_6m', 'Último Pedido 6m'],
  ['Data', 'Data Captado'],
  ['DataOcorrenciaFaturado', 'Data Ocorrência Faturado'],
  ['IDIndustria', 'ID Indústria'],
  ['IDLojista', 'ID Lojista'],
  ['MesReferencia', 'Mês de referência'],
  ['NomeIndustria', 'Indústria'],
  ['NomeDistribuidor', 'Distribuidor'],
  ['NomeLojista', 'Nome Lojista'],
  ['RazaoSocialLojista', 'Razão Social Lojista'],
  ['SegmentoLojista', 'Segmento Lojista'],
  ['ApenasUnilever90Dias', 'Cliente exclusivo UL'],
  ['TamanhoUL', 'Tamanho UL'],
  ['DataUltimoPedido', 'Data do último pedido'],
  ['ValorUltimoPedido', 'Valor do último pedido'],
  ['MetodoPagamentoUltimoPedido', 'Método de pagamento do último pedido'],
  ['CanaldeVendas', 'Canal de vendas'],
  ['VendedorAssociado', 'Vendedor associado'],
  ['DataAtualizacaoTabela', 'Atualização da tabela (UTC)'],
]

function getStringDate(date: any) {
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()
  const dayFormatted = day < 10 ? '0' + day : day.toString()
  const monthFormatted = month < 10 ? '0' + month : month.toString()
  return `${year}-${monthFormatted}-${dayFormatted}`
}

function getColumnHeader(colName: any) {
  const found = REPLACE_COLUMNS_NAME.find(([original]) => original === colName)
  if (found) return found[1]
  return colName
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, (s: any) => s.toUpperCase())
    .replace(/\s+/g, ' ')
    .trim()
}

function getInitialColumnWidth(header: string) {
  return Math.min(MAX_COLUMN_WIDTH, Math.max(DEFAULT_COLUMN_WIDTH, header.length * 9 + 72))
}

function isInteractiveTarget(target: EventTarget | null) {
  if (!(target instanceof Element)) return false

  return Boolean(
    target.closest(
      'a, button, input, select, textarea, label, [role="button"], [contenteditable="true"], [data-row-click-ignore="true"]'
    )
  )
}

function extractFileNameFromUrl(urlStr: string) {
  try {
    const url = new URL(urlStr)
    const last = url.pathname.split('/').filter(Boolean).pop()
    return last || 'manual.pdf'
  } catch {
    const last = urlStr.split('/').filter(Boolean).pop()
    return last || 'manual.pdf'
  }
}

function getDefaultLimit(report: string) {
  return report === 'cadastro_distribuidores' ? 250 : 100
}

export const ReportSystem: React.FC<ScreenProps> = ({report = '', title = '', reportMethod = ''}) => {
  const [data, setData] = useState<any[]>([])
  const [columns, setColumns] = useState<any[]>([])
  const [sorting, setSorting] = useState<any>([])
  const [columnSizing, setColumnSizing] = useState<Record<string, number>>({})
  const [isLoading, setIsLoading] = useState(false)
  const [filters, setFilters] = useState<any>(null)
  const [showFilterModal, setShowFilterModal] = useState(true)
  const [limit, setLimit] = useState(() => getDefaultLimit(report))
  const [totalCount, setTotalCount] = useState(0)
  const [loadError, setLoadError] = useState('')
  const [optionsError, setOptionsError] = useState('')
  const [optionsRetry, setOptionsRetry] = useState(0)
  const [reportOptionSources, setReportOptionSources] = useState<Record<string, Array<{value: string; label: string}>>>({})
  const [loadingOptionSources, setLoadingOptionSources] = useState<Record<string, boolean>>({})
  const columnHelper = createColumnHelper<any>()

  const location = useLocation()
  const isUnileverPromoReport = report === 'cadastro_promo_ul' || report === 'consumo_promo_ul'
  const filtersReport = useRef<string | null>(null)
  const requestSequence = useRef(0)
  const tableScrollRef = useRef<HTMLDivElement | null>(null)
  const rowPointerInteractionRef = useRef<RowPointerInteraction | null>(null)
  const rowOpenTimerRef = useRef<number | null>(null)
  const [tableMaxHeight, setTableMaxHeight] = useState<number | null>(null)
  const [selectedRowDetails, setSelectedRowDetails] = useState<SelectedRowDetails | null>(null)

  const [downloadError, setDownloadError] = useState(false)
  const [downloadURL, setDownloadURL] = useState<any>('')
  const [downloadModal, showDownloadModal] = useState<boolean>(false)
  const [jobId, setJobId] = useState<any>(null)

  const [showHelpModal, setShowHelpModal] = useState(false)
  const [helpPdfUrl, setHelpPdfUrl] = useState<string | null>(null)
  const [helpFileName, setHelpFileName] = useState<string | null>(null)
  const [hasPdf, setHasPdf] = useState(false)
  const [isCheckingManual, setIsCheckingManual] = useState(false)

  const checkManual = async () => {
    setIsCheckingManual(true)
    try {
      const response: any = await API.getReportManual(report)

      const src = response?.success ? response?.data?.src : null
      if (src) {
        setHasPdf(true)
        setHelpPdfUrl(src)
        setHelpFileName(extractFileNameFromUrl(src))
      } else {
        setHasPdf(false)
        setHelpPdfUrl(null)
        setHelpFileName(null)
      }
    } catch (error) {
      console.error('Error checking manual:', error)
      setHasPdf(false)
      setHelpPdfUrl(null)
      setHelpFileName(null)
    } finally {
      setIsCheckingManual(false)
    }
  }

  useEffect(() => {
    // Sempre que mudar a rota / tipo de relatório: reset + checa manual do relatório
    filtersReport.current = null
    requestSequence.current += 1
    setFilters(null)
    setLoadError('')
    setData([])
    setColumns([])
    setTotalCount(0)
    setSorting([])
    setColumnSizing({})
    setSelectedRowDetails(null)
    if (rowOpenTimerRef.current !== null) {
      window.clearTimeout(rowOpenTimerRef.current)
      rowOpenTimerRef.current = null
    }
    setLimit(getDefaultLimit(report))
    setShowFilterModal(true)
    setIsLoading(false)

    if (report) {
      checkManual()
    } else {
      setHasPdf(false)
      setHelpPdfUrl(null)
      setHelpFileName(null)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname, report])

  useEffect(() => {
    return () => {
      if (rowOpenTimerRef.current !== null) {
        window.clearTimeout(rowOpenTimerRef.current)
      }
    }
  }, [])

  useEffect(() => {
    if (isLoading) return
    if (!data.length) {
      setTableMaxHeight(null)
      return
    }

    const updateTableMaxHeight = () => {
      const container = tableScrollRef.current
      if (!container) return

      const viewportHeight = window.visualViewport?.height || window.innerHeight
      const availableHeight = Math.floor(viewportHeight - Math.max(container.getBoundingClientRect().top, 0) - 24)
      const viewportLimit = Math.max(120, Math.floor(viewportHeight - 24))
      const comfortableMinimum = Math.min(280, viewportLimit)
      const nextHeight = Math.min(viewportLimit, Math.max(comfortableMinimum, availableHeight))

      setTableMaxHeight((current) => current === nextHeight ? current : nextHeight)
    }

    const animationFrame = window.requestAnimationFrame(updateTableMaxHeight)
    window.addEventListener('resize', updateTableMaxHeight)
    window.visualViewport?.addEventListener('resize', updateTableMaxHeight)

    return () => {
      window.cancelAnimationFrame(animationFrame)
      window.removeEventListener('resize', updateTableMaxHeight)
      window.visualViewport?.removeEventListener('resize', updateTableMaxHeight)
    }
  }, [data.length, filters, location.pathname, isLoading])

  useEffect(() => {
    let active = true

    setOptionsError('')

    if (report === 'lojas_quase_fidelizadas') {
      const sources = {
        lojasQuaseFidelizadasIndustries: 'industries',
        lojasQuaseFidelizadasDistributors: 'distributors',
        lojasQuaseFidelizadasSegmentos: 'segmentos',
        lojasQuaseFidelizadasTamanhosUL: 'tamanhosUL',
      }
      const emptySources = Object.fromEntries(Object.keys(sources).map((source) => [source, []]))
      setReportOptionSources(emptySources)
      setLoadingOptionSources(Object.fromEntries(Object.keys(sources).map((source) => [source, true])))

      API.getLojasQuaseFidelizadasOptions()
        .then((response: any) => {
          if (!active) return
          if (!response?.success || !response.data) throw new Error('Opções indisponíveis')
          const optionSources = Object.fromEntries(Object.entries(sources).map(([source, key]) => {
            const values = Array.isArray(response.data[key]) ? response.data[key] : []
            const uniqueValues = Array.from(new Set(values
              .filter((value: any) => value !== null && value !== undefined && String(value).trim() !== '')
              .map((value: any) => String(value)))) as string[]
            uniqueValues.sort((left, right) => left.localeCompare(right, 'pt-BR'))
            return [source, uniqueValues.map((value) => ({value, label: value}))]
          }))
          setReportOptionSources(optionSources)
        })
        .catch(() => {
          if (!active) return
          setReportOptionSources(emptySources)
          setOptionsError('Não foi possível carregar as listas de filtros. Tente novamente.')
        })
        .finally(() => {
          if (!active) return
          setLoadingOptionSources(Object.fromEntries(Object.keys(sources).map((source) => [source, false])))
        })

      return () => { active = false }
    }

    if (report === 'faixa_cep_lojista') {
      const distributorSource = 'faixaCepLojistaDistributors'
      const industrySource = 'faixaCepLojistaIndustries'
      const loadingSources = {
        [distributorSource]: true,
        [industrySource]: true,
      }

      setReportOptionSources({})
      setLoadingOptionSources(loadingSources)

      API.getFaixaCepLojistaOptions()
        .then((response: any) => {
          if (!active) return

          const toOptions = (values: any) => {
            const normalizedValues = (Array.isArray(values) ? values : [])
              .map((value: any) => String(value || '').trim())
              .filter(Boolean)
            const uniqueValues = Array.from(new Set(normalizedValues)) as string[]
            uniqueValues.sort((left, right) => left.localeCompare(right, 'pt-BR'))
            return uniqueValues.map((value) => ({value, label: value}))
          }

          setReportOptionSources({
            [distributorSource]: toOptions(response?.data?.distributors),
            [industrySource]: toOptions(response?.data?.industries),
          })
        })
        .catch((error: any) => {
          if (!active) return
          console.error('Erro ao carregar opções do relatório Faixa de CEP - Lojista:', error)
          setReportOptionSources({[distributorSource]: [], [industrySource]: []})
        })
        .finally(() => {
          if (!active) return
          setLoadingOptionSources({[distributorSource]: false, [industrySource]: false})
        })

      return () => {
        active = false
      }
    }

    if (report !== 'cadastro_lojista_interno') {
      setReportOptionSources({})
      setLoadingOptionSources({})
      return () => {
        active = false
      }
    }

    setLoadingOptionSources({cadastroLojistaInternoCities: true})
    API.getCadastroLojistaInternoCities()
      .then((response: any) => {
        if (!active) return

        const rows = Array.isArray(response?.data) ? response.data : []
        const values = rows
          .map((row: any) => Array.isArray(row) ? row[0] : row?.Cidade)
          .filter((value: any) => value !== null && value !== undefined && String(value).trim() !== '')
          .map((value: any) => String(value).trim())
        const uniqueValues = Array.from(new Set(values)) as string[]
        uniqueValues.sort((left, right) => left.localeCompare(right, 'pt-BR'))

        setReportOptionSources({
          cadastroLojistaInternoCities: uniqueValues.map((value) => ({value, label: value})),
        })
      })
      .catch((error: any) => {
        if (!active) return
        console.error('Erro ao carregar cidades do Cadastro Lojista Interno:', error)
        setReportOptionSources({cadastroLojistaInternoCities: []})
      })
      .finally(() => {
        if (!active) return
        setLoadingOptionSources({cadastroLojistaInternoCities: false})
      })

    return () => {
      active = false
    }
  }, [location.pathname, report, optionsRetry])

  useEffect(() => {
    // Só carrega dados se já tiver filtros
    if (!filters || filtersReport.current !== report) return
    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit, filters, report])

  const loadData = async () => {
    if (!filters || filtersReport.current !== report) return

    const requestId = ++requestSequence.current
    setIsLoading(true)
    setLoadError('')

    const configuredFilters = ReportsData[report as keyof typeof ReportsData]
    const hasDate = Array.isArray(configuredFilters) && configuredFilters.some((filter: any) => {
      return filter.name === 'dtstart'
    })

    try {
      const response = await (API as any)[
        report == 'infrapay'
          ? 'infrapayReport'
          : isUnileverPromoReport
            ? 'getUnileverPromoReport'
            : 'getIexpReport'
      ](
        filters ||
          (hasDate
            ? {
                dtstart: getStringDate(new Date(new Date().setDate(new Date().getDate() - 7))),
                dtend: getStringDate(new Date()),
              }
            : {}),
        report,
        false,
        limit
      )

      if (requestId !== requestSequence.current) return

      if (report === 'lojas_quase_fidelizadas' && response?.success === false) {
        throw new Error('Falha ao consultar o relatório')
      }

      if (!response || !Array.isArray(response.columns) || !Array.isArray(response.data)) {
        if (report === 'lojas_quase_fidelizadas') throw new Error('Resposta inválida do relatório')
        setColumns([])
        setData([])
        setTotalCount(0)
        return
      }

      const formattedColumns = formatColumns(response.columns)
      const formattedData = response.data

      // Start each completed search at the first row and column.
      if (tableScrollRef.current) {
        tableScrollRef.current.scrollTop = 0
        tableScrollRef.current.scrollLeft = 0
      }

      setColumns(formattedColumns)
      setData(formattedData)
      setTotalCount(response.counter)
    } catch (error) {
      if (requestId !== requestSequence.current) return
      console.error('Error loading data:', error)
      if (report === 'lojas_quase_fidelizadas') {
        setLoadError('Não foi possível carregar o relatório. Tente novamente.')
      }
      setColumns([])
      setData([])
      setTotalCount(0)
    } finally {
      if (requestId === requestSequence.current) {
        setIsLoading(false)
      }
    }
  }

  const formatColumns = (cols: any) => {
    return (Array.isArray(cols) ? cols : []).map((col: any, idx: any) => {
      const displayName = getColumnHeader(col)
      return columnHelper.accessor(idx.toString(), {
        header: displayName,
        cell: (info: any) => formatCellValue(info.getValue()),
        enableSorting: true,
        enableResizing: true,
        size: getInitialColumnWidth(displayName),
        minSize: MIN_COLUMN_WIDTH,
        maxSize: MAX_COLUMN_WIDTH,
        meta: {
          originalName: col,
          displayName,
        },
      })
    })
  }

  const table = useReactTable({
    data,
    columns,
    state: {sorting, columnSizing},
    onSortingChange: setSorting,
    onColumnSizingChange: setColumnSizing,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    columnResizeMode: 'onChange',
    enableColumnResizing: true,
  })

  const tableColumnWidths = useMemo(() => {
    const widths: Record<string, string> = {}
    table.getAllLeafColumns().forEach((column) => {
      widths[`--report-column-${column.id}-width`] = `${column.getSize()}px`
    })
    return widths
  }, [table, columns, columnSizing])

  const clearPendingRowOpen = useCallback(() => {
    if (rowOpenTimerRef.current !== null) {
      window.clearTimeout(rowOpenTimerRef.current)
      rowOpenTimerRef.current = null
    }
  }, [])

  const openRowDetails = useCallback((row: any) => {
    const visibleRowIndex = table.getRowModel().rows.findIndex((visibleRow: any) => visibleRow.id === row.id)
    const fields = row.getVisibleCells().map((cell: any) => {
      const meta = cell.column.columnDef.meta as {originalName?: string; displayName?: string} | undefined
      return {
        key: cell.column.id + '-' + (meta?.originalName || cell.column.id),
        label: meta?.displayName || meta?.originalName || cell.column.id,
        value: formatCellValue(cell.getValue()),
      }
    })

    setSelectedRowDetails({
      rowNumber: Math.max(visibleRowIndex, 0) + 1,
      fields,
    })
  }, [table])

  const handleRowPointerDown = useCallback((event: React.PointerEvent<HTMLTableRowElement>, row: any) => {
    if (event.button !== 0 || isInteractiveTarget(event.target)) {
      rowPointerInteractionRef.current = null
      return
    }

    rowPointerInteractionRef.current = {
      rowId: row.id,
      startX: event.clientX,
      startY: event.clientY,
      moved: false,
    }
  }, [])

  const handleRowPointerMove = useCallback((event: React.PointerEvent<HTMLTableRowElement>, row: any) => {
    const interaction = rowPointerInteractionRef.current
    if (!interaction || interaction.rowId !== row.id || interaction.moved) return

    const movedX = Math.abs(event.clientX - interaction.startX)
    const movedY = Math.abs(event.clientY - interaction.startY)
    if (movedX > ROW_DRAG_TOLERANCE_PX || movedY > ROW_DRAG_TOLERANCE_PX) {
      interaction.moved = true
    }
  }, [])

  const handleRowClick = useCallback((event: React.MouseEvent<HTMLTableRowElement>, row: any) => {
    const interaction = rowPointerInteractionRef.current
    rowPointerInteractionRef.current = null

    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.ctrlKey ||
      event.metaKey ||
      event.shiftKey ||
      event.altKey ||
      event.detail !== 1 ||
      isInteractiveTarget(event.target) ||
      !interaction ||
      interaction.rowId !== row.id ||
      interaction.moved
    ) {
      return
    }

    const movedX = Math.abs(event.clientX - interaction.startX)
    const movedY = Math.abs(event.clientY - interaction.startY)
    const selection = window.getSelection()
    if (
      movedX > ROW_DRAG_TOLERANCE_PX ||
      movedY > ROW_DRAG_TOLERANCE_PX ||
      (selection && !selection.isCollapsed)
    ) {
      return
    }

    clearPendingRowOpen()
    rowOpenTimerRef.current = window.setTimeout(() => {
      openRowDetails(row)
      rowOpenTimerRef.current = null
    }, ROW_CLICK_DELAY_MS)
  }, [clearPendingRowOpen, openRowDetails])

  const handleRowPointerCancel = useCallback(() => {
    rowPointerInteractionRef.current = null
  }, [])

  const handleRowKeyDown = useCallback((event: React.KeyboardEvent<HTMLTableRowElement>, row: any) => {
    if ((event.key === 'Enter' || event.key === ' ') && !isInteractiveTarget(event.target)) {
      event.preventDefault()
      clearPendingRowOpen()
      openRowDetails(row)
    }
  }, [clearPendingRowOpen, openRowDetails])

  async function exportXLSX() {
    setDownloadError(false)
    showDownloadModal(true)
    if (totalCount > 2000000) return

    setJobId(null)
    try {
      const response = await API[
        report == 'infrapay'
          ? 'infrapayReport'
          : isUnileverPromoReport
            ? 'getUnileverPromoReport'
            : 'getIexpReport'
      ](
        filters || {
          dtstart: getStringDate(new Date(new Date().setDate(new Date().getDate() - 7))),
          dtend: getStringDate(new Date()),
        },
        report,
        true,
        limit
      )

      if (!response || !response.success) {
        setDownloadError(true)
      } else {
        setJobId(response.data)
      }
    } catch {
      setDownloadError(true)
    }
  }

  return (
    <StyledWrapper>
      <Global
        styles={css`
          .filter-modal-dialog {
            width: 800px !important;
            max-width: 80vw;
          }
        `}
      />
      <div className='min-h-screen bg-gray-50 py-8'>
        <div className='mx-auto px-4 sm:px-6 lg:px-8'>
          <div className='mb-8'>
            <div className='flex items-center justify-between'>
              <PageTitle>{title}</PageTitle>
              <div className='flex items-center gap-4'>
                <Select
                  className='w-32'
                  value={{value: limit, label: limit}}
                  onChange={(option: any) => setLimit(option.value)}
                  options={[
                    {value: 100, label: 100},
                    {value: 250, label: 250},
                    {value: 500, label: 500},
                    {value: 1000, label: 1000},
                  ]}
                />
                <button
                  onClick={() => setShowFilterModal(true)}
                  className='inline-flex items-center px-4 py-2 bg-white text-gray-700 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors'
                >
                  <Filter className='w-5 h-5 mr-2' />
                  Filtros
                </button>
                <button
                  onClick={() => exportXLSX()}
                  className='inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors'
                >
                  <Download className='w-5 h-5 mr-2' />
                  Exportar XLSX
                </button>
                { !isCheckingManual && (hasPdf || isSuperAdmin()) ? 
                <button
                  onClick={() => setShowHelpModal(true)}
                  disabled={isCheckingManual}
                  className={`inline-flex items-center p-2 rounded-lg transition-all shadow-sm ${
                    hasPdf ? 'bg-blue-100 text-blue-600 hover:bg-blue-200' : 'bg-red-100 text-red-600 hover:bg-red-200'
                  } ${isCheckingManual ? 'opacity-60 cursor-not-allowed' : ''}`}
                  title={
                    isCheckingManual
                      ? 'Verificando manual...'
                      : hasPdf
                        ? 'Ver manual de ajuda'
                        : 'Adicionar manual de ajuda'
                  }
                >
                  <HelpCircle className='w-5 h-5' />
                </button> : null }
              </div>
            </div>

            {!isLoading && !loadError && filters && (
              <div className='mt-6 grid gap-6 md:grid-cols-2 lg:grid-cols-3'>
                <StatsCard
                  title='Total de Resultados'
                  value={totalCount}
                  description='Total de registros na base'
                  icon={<FileSpreadsheet className='w-6 h-6' />}
                />
                <StatsCard
                  title='Resultados Visíveis'
                  value={data.length}
                  description={`Mostrando ${Math.min(limit, data.length)} registros`}
                  icon={<Building2 className='w-6 h-6' />}
                />
              </div>
            )}
          </div>

          <div className='bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden' aria-busy={isLoading}>
            {isLoading && (
              <div className='flex flex-col items-center justify-center py-12' role='status'>
                <Loader2 className='w-8 h-8 text-blue-500 animate-spin' />
                <p className='mt-4 text-gray-500'>Carregando dados...</p>
              </div>
            )}
            {/* Keep the table mounted while loading so closing filters does not dispose every cell. */}
            <div hidden={isLoading}>
            {loadError ? (
              <div role='alert' className='flex flex-col items-center justify-center py-12'>
                <p className='text-red-600'>{loadError}</p>
                <button className='btn btn-light-primary mt-3' onClick={() => loadData()}>
                  Tentar novamente
                </button>
              </div>
            ) : !filters ? (
              <div className='flex flex-col items-center justify-center py-12'>
                <div className='bg-gray-100 rounded-full p-3'>
                  <Filter className='w-8 h-8 text-gray-400' />
                </div>
                <p className='mt-4 text-gray-600'>Defina os filtros iniciais para visualizar os dados do relatório.</p>
                <button
                  onClick={() => setShowFilterModal(true)}
                  className='mt-4 inline-flex items-center px-4 py-2 bg-white text-gray-700 rounded-lg border border-gray-200 hover:bg-gray-50 transition-colors'
                >
                  <Filter className='w-5 h-5 mr-2' />
                  Abrir filtros
                </button>
              </div>
            ) : !data.length ? (
              <div className='flex flex-col items-center justify-center py-12'>
                <div className='bg-gray-100 rounded-full p-3'>
                  <FileSpreadsheet className='w-8 h-8 text-gray-400' />
                </div>
                <p className='mt-4 text-gray-500'>Nenhum registro encontrado com os filtros selecionados</p>
              </div>
            ) : (
              <div className='min-w-0'>
                <div className='flex flex-wrap items-center justify-between gap-2 border-b border-gray-200 bg-gray-50 px-4 py-2 text-xs text-gray-500'>
                  <span>Arraste a divisória entre os títulos para ajustar a largura. Dê dois cliques para restaurar.</span>
                  <span>Clique em uma linha para ver todos os campos.</span>
                </div>
                <div
                  ref={tableScrollRef}
                  className='overflow-auto'
                  style={{
                    maxHeight: tableMaxHeight ? tableMaxHeight + 'px' : 'calc(100dvh - 24px)',
                    overscrollBehavior: 'contain',
                  }}
                >
                  <table
                    className='table-fixed divide-y divide-gray-200'
                    style={{...tableColumnWidths, width: table.getTotalSize(), minWidth: '100%'}}
                  >
                    <thead className='bg-gray-50'>
                      {table.getHeaderGroups().map((headerGroup: any) => (
                        <tr key={headerGroup.id}>
                          {headerGroup.headers.map((header: any) => {
                            const sorted = header.column.getIsSorted()
                            return (
                              <th
                                key={header.id}
                                scope='col'
                                onClick={header.column.getToggleSortingHandler()}
                                title={String(header.column.columnDef.header || '')}
                                style={{width: header.getSize()}}
                                className='group sticky top-0 z-10 border-b border-r border-gray-200 bg-gray-50 px-4 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500 hover:bg-gray-100 select-none'
                              >
                                <div className='flex min-w-0 cursor-pointer items-center gap-2 pr-2'>
                                  <span className='truncate'>
                                    {flexRender(header.column.columnDef.header, header.getContext())}
                                  </span>
                                  <span className='shrink-0'>
                                    {sorted === false && <ArrowUpDown className='w-4 h-4 opacity-50' />}
                                    {sorted === 'asc' && <ArrowUp className='w-4 h-4 text-blue-600' />}
                                    {sorted === 'desc' && <ArrowDown className='w-4 h-4 text-blue-600' />}
                                  </span>
                                </div>
                                <div
                                  role='separator'
                                  aria-orientation='vertical'
                                  aria-label={'Redimensionar coluna ' + String(header.column.columnDef.header || '')}
                                  data-row-click-ignore='true'
                                  onClick={(event) => event.stopPropagation()}
                                  onDoubleClick={(event) => {
                                    event.stopPropagation()
                                    header.column.resetSize()
                                  }}
                                  onMouseDown={header.getResizeHandler()}
                                  onTouchStart={header.getResizeHandler()}
                                  className={
                                    'absolute right-0 top-0 h-full w-2 cursor-col-resize touch-none ' +
                                    (header.column.getIsResizing() ? 'bg-blue-500' : 'hover:bg-blue-300')
                                  }
                                />
                              </th>
                            )
                          })}
                        </tr>
                      ))}
                    </thead>
                    <ReportTableBody
                      rows={table.getRowModel().rows}
                      columns={columns}
                      onRowPointerDown={handleRowPointerDown}
                      onRowPointerMove={handleRowPointerMove}
                      onRowPointerCancel={handleRowPointerCancel}
                      onRowClick={handleRowClick}
                      onRowDoubleClick={clearPendingRowOpen}
                      onRowKeyDown={handleRowKeyDown}
                    />
                  </table>
                </div>
                </div>
            )}
            </div>
          </div>
        </div>

        <Modal
          animation={false}
          show={selectedRowDetails !== null}
          onHide={() => setSelectedRowDetails(null)}
          centered
          scrollable
          size='xl'
        >
          <Modal.Header closeButton>
            <Modal.Title>Detalhes do registro {selectedRowDetails?.rowNumber}</Modal.Title>
          </Modal.Header>
          <Modal.Body className='bg-gray-50'>
            <dl className='grid grid-cols-1 gap-4 md:grid-cols-2'>
              {selectedRowDetails?.fields.map((field) => (
                <div key={field.key} className='min-w-0 rounded-lg border border-gray-200 bg-white p-4'>
                  <dt className='mb-1 text-xs font-semibold uppercase tracking-wide text-gray-500'>
                    {field.label}
                  </dt>
                  <dd className='mb-0 whitespace-pre-wrap break-words text-sm text-gray-900'>{field.value}</dd>
                </div>
              ))}
            </dl>
          </Modal.Body>
        </Modal>

        <Modal
          animation={false}
          dialogClassName='filter-modal-dialog w-1000px'
          show={showFilterModal}
          onHide={() => setShowFilterModal(false)}
          centered
          backdrop='static'
        >
          <FilterModal
            key={location.pathname}
            filters={ReportsData[report as keyof typeof ReportsData]}
            optionSources={reportOptionSources}
            loadingOptionSources={loadingOptionSources}
            optionsLoading={report === 'lojas_quase_fidelizadas' && Object.values(loadingOptionSources).some(Boolean)}
            optionsError={optionsError}
            onRetryOptions={() => setOptionsRetry((current) => current + 1)}
            data={filters}
            onApply={(newFilters: any) => {
              filtersReport.current = report
              // Hide the old table before Modal restores focus and triggers layout.
              setIsLoading(true)
              setFilters(newFilters)
              setShowFilterModal(false)
            }}
            onClose={() => setShowFilterModal(false)}
          />
        </Modal>

        <Modal
          animation={false}
          id='modal_message'
          tabIndex={-1}
          dialogClassName='modal-dialog modal-dialog-centered mw-500px'
          contentClassName='bg-transparent border-0 shadow-none'
          backdropClassName='bg-black bg-opacity-70'
          show={downloadModal}
        >
          <DownloadModal
            url={downloadURL}
            jobId={jobId}
            error={downloadError}
            counter={totalCount}
            onClose={() => {
              showDownloadModal(false)
              setDownloadURL('')
            }}
          />
        </Modal>

        <Modal animation={false} show={showHelpModal} onHide={() => setShowHelpModal(false)} centered size='xl'>
          <HelpModal
            reportName={report}
            pdfUrl={helpPdfUrl || undefined}
            fileName={helpFileName || undefined}
            onClose={() => setShowHelpModal(false)}
            onUploadSuccess={(pdfUrl) => {
              setHelpPdfUrl(pdfUrl)
              setHasPdf(true)
              setHelpFileName(extractFileNameFromUrl(pdfUrl))
              // garante que o status do botão reflita o estado real no backend
              checkManual()
            }}
          />
        </Modal>
      </div>
    </StyledWrapper>
  )
}

export default ReportSystem
